
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["connectWS","sendEvent","closeWS","test"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "4625820250fbec3113d9.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "4625820250fbec3113d9.worker.js");
					addMethods(w, methods)
					
					return w
				}
			